import type { BubbleHelp } from "../../@types/mapviewxs";

const KEY_SHOW_HELP_TOOLTIP = "showHelpTooltip";

export interface Input {
  help?: BubbleHelp;
}

export interface State {
  opened: boolean;
}

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      opened: false,
    };
  }

  onInput(input: Input) {
    this.showTooltipOnce(input.help);
  }

  onMount() {
    this.showTooltipOnce(this.input.help);
  }

  showTooltipOnce(model: BubbleHelp | undefined) {
    if (!model || typeof window === "undefined") return;

    const shouldOpen = window.localStorage.getItem(KEY_SHOW_HELP_TOOLTIP);
    if (shouldOpen !== "false") {
      this.state.opened = true;
      window.localStorage.setItem(KEY_SHOW_HELP_TOOLTIP, "false");
    }
  }
}
